import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';
import {
  readPendingReferralCoupon,
  clearPendingReferralCoupon,
} from './referralShare';
import { trackReferralCodeCopied } from './userJourneyTracker';
import './ReferralReturnCouponModal.css';

export default function ReferralReturnCouponModal({ suppress }) {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [pending, setPending] = useState(null);
  const [copyLabel, setCopyLabel] = useState('Copy');

  const sync = useCallback(() => {
    if (suppress || loading) {
      setVisible(false);
      return;
    }

    const p = readPendingReferralCoupon();
    const uid = user?.uid;

    if (!isAuthenticated || !uid || !p || p.userId !== uid) {
      setVisible(false);
      return;
    }

    setPending(p);
    setVisible(true);
  }, [user?.uid, isAuthenticated, loading, suppress]);

  useEffect(() => {
    sync();
  }, [sync, location.pathname]);

  useEffect(() => {
    const onPending = () => sync();
    window.addEventListener('makereels-referral-pending', onPending);
    return () => window.removeEventListener('makereels-referral-pending', onPending);
  }, [sync]);

  const handleCopy = async () => {
    if (!pending?.couponCode) return;
    try {
      await navigator.clipboard.writeText(pending.couponCode);
      trackReferralCodeCopied();
      setCopyLabel('Copied!');
      clearPendingReferralCoupon();
      window.setTimeout(() => {
        setVisible(false);
        setPending(null);
        setCopyLabel('Copy');
      }, 700);
    } catch (_) {
      setCopyLabel('Failed');
      window.setTimeout(() => setCopyLabel('Copy'), 2000);
    }
  };

  if (!visible || !pending) {
    return null;
  }

  return (
    <div
      className="referral-return-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="referral-return-title"
    >
      <div className="referral-return-backdrop" aria-hidden="true" />
      <div className="referral-return-dialog">
        <img
          className="referral-return-gift-image"
          src="/refferal_gift.png"
          alt="Referral gift"
        />
        <div className="referral-return-gift-fade" aria-hidden="true" />
        <h2 id="referral-return-title" className="referral-return-title">
          Your Coupon Code
        </h2>
        <p className="referral-return-sub">
          Copy your code & use it at checkout to access Premium.
        </p>
        <div className="referral-return-code-box">
          <div className="referral-return-code">{pending.couponCode}</div>
          <button
            type="button"
            className="referral-return-copy-btn"
            onClick={handleCopy}
          >
            {copyLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
